'use client';

import * as React from 'react';
import { useEffect, useState } from 'react';
import { CmsParams } from '@/lib/cms-params.type';
import HeaderTickets, { IHeaderTicketProps } from '@/components/ui/HeaderTickets';
import { isAuthenticated } from '@/lib/helper/is-authenticated';
import { FrontUserTicketBalanceV2ResponseDto, FrontUserTicketService } from '@/lib/jp-api/requests';

export type AllTicketsBalanceProps = {
  cmsParams: CmsParams;
};
export const HeaderTicketsBalance: React.FC<AllTicketsBalanceProps> = ({ cmsParams }) => {
  const isUserAuthenticated = isAuthenticated(cmsParams);
  const [balances, setBalance] = useState<FrontUserTicketBalanceV2ResponseDto[]>([]);

  useEffect(() => {
    if (!isUserAuthenticated) return;
    FrontUserTicketService.getV2FrontUserTicketBalance({
      language: cmsParams.language,
      hostname: cmsParams.brand,
    }).then((data) => setBalance(data.balances));
  }, [cmsParams, isUserAuthenticated]);

  if (!isUserAuthenticated) return null;

  const tickets: IHeaderTicketProps[] = balances.map((balance) => ({
    label: balance.ticket.label,
    imageUrl: balance.ticket.imageSrc,
    tickets: balance.ticketAmount,
    href: '',
  }));

  return <HeaderTickets tickets={tickets} />;
};
